// Lightweight product gallery - replaces jQuery + Slick
// Syncs main image gallery with thumbnail gallery
(function () {
  'use strict';

  function initGallery() {
    // Two .product-single__photos exist when media_position is 'right':
    //   [0] = mobile only (parent has medium-hide large-up-hide → hidden ≥750px)
    //   [1] = tablet/desktop only (parent has small-hide → hidden <750px)
    // matchMedia reliably picks the visible one without waiting for CSS/layout.
    var allMainLists = document.querySelectorAll('.product-single__photos');
    var mainList = allMainLists[0];
    if (allMainLists.length > 1 && window.matchMedia('(min-width: 750px)').matches) {
      mainList = allMainLists[1];
    }
    var thumbList = document.querySelector('.product-single__thumbnails');
    if (!mainList) return;

    var slides = Array.from(mainList.children);
    var thumbs = thumbList ? Array.from(thumbList.children) : [];
    var currentIndex = 0;
    var isAnimating = false;

    // Mark containers as initialized (replaces slick-initialized behavior)
    mainList.classList.add('gallery-initialized');
    if (thumbList) thumbList.classList.add('gallery-initialized');

    // --- MAIN GALLERY SETUP ---

    // Hoist the zoom icon out of the slides so it doesn't fade with them
    var firstZoomIcon = mainList.querySelector('.product__media-icon');
    if (firstZoomIcon) {
      // Clone the first one and place it directly on the gallery container
      var fixedZoom = firstZoomIcon.cloneNode(true);
      fixedZoom.classList.add('product__media-icon--fixed');
      // The source button is authored aria-hidden (decorative per-slide icon),
      // but this clone is the live, focusable zoom control. aria-hidden on a
      // focusable element is invalid — the browser blocks it on focus — so
      // expose it to assistive tech with a real accessible name instead.
      fixedZoom.removeAttribute('aria-hidden');
      if (!fixedZoom.getAttribute('aria-label')) {
        fixedZoom.setAttribute('aria-label', 'View media');
      }
      // Wire click to open the CURRENT slide's modal.
      // Resolve the live slide's real opener button (it carries the correct
      // data-media-id) and call the modal's show() directly — the same contract
      // as Dawn's native <modal-opener>. We deliberately avoid opener.click():
      // a synthesized click bubbles to the <modal-opener> wrapper, whose
      // dr-modal-links handler re-opens the modal with the wrapper element —
      // which has no data-media-id — producing a null activeMedia crash in
      // product-modal.js. Calling show(button) hands it the right media id.
      fixedZoom.addEventListener('click', function () {
        var currentSlide = slides[currentIndex];
        if (!currentSlide) return;
        var button = currentSlide.querySelector('modal-opener button[data-media-id], .product__media-icon[data-media-id]');
        var openerEl = currentSlide.querySelector('modal-opener[data-modal], [data-modal]');
        if (!button || !openerEl) return;
        var modal = document.querySelector(openerEl.getAttribute('data-modal'));
        if (modal && typeof modal.show === 'function') modal.show(button);
      });
      mainList.appendChild(fixedZoom);
      // Hide the per-slide icons
      mainList.querySelectorAll('li .product__media-icon').forEach(function (icon) {
        icon.style.display = 'none';
      });
    }

    // Set initial state: all slides get slick-slide class, first gets slick-current
    slides.forEach(function (slide, i) {
      slide.classList.add('slick-slide');
      if (i === 0) {
        slide.classList.add('slick-current', 'slick-active');
      } else {
        slide.classList.remove('slick-active');
      }
    });

    // Decode every slide up front. The hidden slides already download (they sit stacked in
    // the viewport at opacity 0, so loading="lazy" fetches them right after init), but mobile
    // Safari/Chrome put off decoding an image until it first paints visible — so the first
    // tap to each slide flashed while it decoded, and only revisits were smooth. decode()
    // waits for the download, then keeps the bitmap ready.
    slides.forEach(function (slide) {
      var img = slide.querySelector('img');
      if (img && typeof img.decode === 'function') img.decode().catch(function () {});
    });

    // Create prev/next arrows (same markup as slick produced)
    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'slick-prev slick-arrow';
    prevBtn.setAttribute('aria-label', 'Previous');

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'slick-next slick-arrow';
    nextBtn.setAttribute('aria-label', 'Next');

    mainList.style.position = 'relative';
    mainList.appendChild(prevBtn);
    mainList.appendChild(nextBtn);

    var navDirection = 0; // 1 = forward/right, -1 = backward/left

    function goToSlide(index, direction) {
      if (isAnimating) return;

      // Determine direction: explicit, or from raw index before wrapping
      if (direction) {
        navDirection = direction;
      } else if (index > currentIndex) {
        navDirection = 1;
      } else if (index < currentIndex) {
        navDirection = -1;
      } else {
        navDirection = 0;
      }

      if (index >= slides.length) {
        index = 0;
      } else if (index < 0) {
        index = slides.length - 1;
      }

      if (index === currentIndex) return;

      isAnimating = true;
      var outgoing = slides[currentIndex];
      var incoming = slides[index];

      // Lock container height to prevent jump when swapping position:relative
      // getBoundingClientRect gives subpixel precision; offsetHeight rounds to int
      // which causes a 1px layout shift on the thumbnails below
      mainList.style.height = mainList.getBoundingClientRect().height + 'px';

      // Fade transition: incoming fades in over outgoing
      // Remove slick-active from outgoing so it drops to z-index 1
      outgoing.classList.remove('slick-active');

      incoming.classList.add('slick-active');
      incoming.style.opacity = '0';

      // Force reflow to ensure browser registers opacity:0 before transitioning
      incoming.offsetHeight;

      incoming.style.transition = 'opacity 300ms linear';
      incoming.style.opacity = '1';

      // Sync thumbnail immediately so both animate together
      currentIndex = index;
      if (thumbList) syncThumbnail(index);

      setTimeout(function () {
        // Swap current: outgoing goes absolute+hidden, incoming goes relative+visible
        outgoing.classList.remove('slick-current');
        outgoing.style.transition = '';
        incoming.classList.add('slick-current');
        incoming.style.transition = '';
        incoming.style.opacity = '';

        // Release fixed height
        mainList.style.height = '';

        isAnimating = false;
      }, 300);
    }

    prevBtn.addEventListener('click', function () {
      goToSlide(currentIndex - 1, -1);
    });

    nextBtn.addEventListener('click', function () {
      goToSlide(currentIndex + 1, 1);
    });

    // Touch/swipe support on main gallery. Wired here, before the thumbnail setup, because
    // that setup returns early for 8 or fewer thumbs — down at the end of the function this
    // only ran for galleries with more than 8 images (apparel swiped, footwear didn't).
    var touchStartX = 0;
    var touchEndX = 0;

    mainList.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    mainList.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          goToSlide(currentIndex + 1, 1);
        } else {
          goToSlide(currentIndex - 1, -1);
        }
      }
    }, { passive: true });

    // --- THUMBNAIL GALLERY SETUP (Slick-style track + translate3d) ---
    if (!thumbList || thumbs.length === 0) return;

    var syncThumbnail;

    var thumbsVisible = 8;
    var totalThumbs = thumbs.length;
    var thumbSlideWidth; // computed after layout
    var thumbsNeedScroll = totalThumbs > thumbsVisible;

    // Add slick classes to original thumbs
    thumbs.forEach(function (thumb, i) {
      thumb.classList.add('slick-slide');
      thumb.setAttribute('data-slick-index', i);
      if (i === 0) {
        thumb.classList.add('slick-current', 'slick-active');
      } else {
        thumb.classList.add('slick-active');
      }
    });

    // If 8 or fewer thumbs, no scrolling/clones/arrows — just highlight active
    if (!thumbsNeedScroll) {
      thumbList.classList.add('gallery-initialized');

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          goToSlide(i);
        });
      });

      syncThumbnail = function (index) {
        thumbs.forEach(function (thumb) {
          thumb.classList.remove('slick-current');
        });
        if (thumbs[index]) {
          thumbs[index].classList.add('slick-current');
        }
      };
      return;
    }

    // Build Slick-style DOM: wrapper > slick-list (viewport) > slick-track (rail)
    var thumbWrapper = document.createElement('div');
    thumbWrapper.className = 'thumbnail-gallery-wrapper';

    var thumbViewport = document.createElement('div');
    thumbViewport.className = 'slick-list';
    // Critical layout styles inline so they don't depend on gallery.css load timing
    thumbViewport.style.overflow = 'hidden';
    thumbViewport.style.width = '100%';

    var thumbTrack = document.createElement('div');
    thumbTrack.className = 'slick-track';
    thumbTrack.style.display = 'flex';

    // Move all original thumbs into the track
    while (thumbList.firstChild) {
      thumbTrack.appendChild(thumbList.firstChild);
    }

    // Prepend clones: last N thumbs cloned before originals (clicking = go left)
    for (var c = totalThumbs - 1; c >= Math.max(0, totalThumbs - thumbsVisible); c--) {
      var preclone = thumbs[c].cloneNode(true);
      preclone.classList.add('slick-cloned');
      preclone.classList.remove('slick-current');
      preclone.setAttribute('data-slick-index', c - totalThumbs);
      (function (idx) {
        preclone.addEventListener('click', function () { goToSlide(idx, -1); });
      })(c);
      thumbTrack.insertBefore(preclone, thumbTrack.firstChild);
    }

    // Append clones: first N thumbs cloned after originals (clicking = go right)
    for (var c = 0; c < Math.min(totalThumbs, thumbsVisible); c++) {
      var postclone = thumbs[c].cloneNode(true);
      postclone.classList.add('slick-cloned');
      postclone.classList.remove('slick-current');
      postclone.setAttribute('data-slick-index', c + totalThumbs);
      (function (idx) {
        postclone.addEventListener('click', function () { goToSlide(idx, 1); });
      })(c);
      thumbTrack.appendChild(postclone);
    }

    // Assemble DOM
    thumbViewport.appendChild(thumbTrack);
    thumbList.appendChild(thumbViewport);

    // Insert wrapper around thumbList
    thumbList.parentNode.insertBefore(thumbWrapper, thumbList);
    thumbWrapper.appendChild(thumbList);

    // Thumbnail arrows (on wrapper, outside the scrolling track)
    var thumbPrev = document.createElement('button');
    thumbPrev.type = 'button';
    thumbPrev.className = 'slick-prev slick-arrow';
    thumbPrev.setAttribute('aria-label', 'Previous');

    var thumbNext = document.createElement('button');
    thumbNext.type = 'button';
    thumbNext.className = 'slick-next slick-arrow';
    thumbNext.setAttribute('aria-label', 'Next');

    thumbWrapper.appendChild(thumbPrev);
    thumbWrapper.appendChild(thumbNext);

    // Click handlers on original thumbs
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        goToSlide(i);
      });
    });

    // Compute slide width and set track dimensions
    function setupThumbDimensions() {
      if (window.innerWidth < 750) return;
      var vpWidth = thumbViewport.offsetWidth;
      // Don't poison widths with 0 — leave slides unsized until container is ready
      if (vpWidth === 0) return;
      thumbSlideWidth = vpWidth / thumbsVisible;
      var allTrackItems = thumbTrack.children;
      for (var i = 0; i < allTrackItems.length; i++) {
        allTrackItems[i].style.width = thumbSlideWidth + 'px';
      }
      thumbTrack.style.width = (allTrackItems.length * thumbSlideWidth) + 'px';
      // Set initial position: skip past prepended clones
      setThumbPosition(getThumbLeft(currentIndex), false);
    }

    // Get translate position for a given slide index
    // slideOffset accounts for prepended clones
    function getThumbLeft(index) {
      var cloneCount = Math.min(totalThumbs, thumbsVisible);
      var slideOffset = thumbSlideWidth * cloneCount * -1;
      return (index * thumbSlideWidth * -1) + slideOffset;
    }

    // Apply translate3d to track, with or without transition
    function setThumbPosition(left, animate) {
      if (animate) {
        thumbTrack.style.transition = 'transform 300ms ease';
      } else {
        thumbTrack.style.transition = 'none';
      }
      thumbTrack.style.transform = 'translate3d(' + Math.ceil(left) + 'px, 0px, 0px)';
    }

    var snapTimer = null;
    // Track the current logical position on the track (can be in clone range)
    var thumbTrackIndex = 0;

    syncThumbnail = function(index) {
      // Clear any pending snap-back from a previous transition
      if (snapTimer) {
        clearTimeout(snapTimer);
        // Snap immediately to the real position before starting new animation
        setThumbPosition(getThumbLeft(thumbTrackIndex % totalThumbs), false);
        snapTimer = null;
      }

      // Update slick-current on all items (originals + clones)
      var allItems = thumbTrack.querySelectorAll('[data-slick-index]');
      allItems.forEach(function (el) {
        el.classList.remove('slick-current');
        var idx = parseInt(el.getAttribute('data-slick-index'));
        if (idx === index || idx === index - totalThumbs || idx === index + totalThumbs) {
          el.classList.add('slick-current');
        }
      });

      if (window.innerWidth < 750) return;

      // Determine the target track index based on direction
      // This ensures we always scroll in the correct direction,
      // using clones when we need to cross the boundary
      var targetTrackIndex = index;

      if (navDirection > 0 && index <= thumbTrackIndex) {
        // Going right but target index is lower — go into appended clones
        targetTrackIndex = index + totalThumbs;
      } else if (navDirection < 0 && index >= thumbTrackIndex) {
        // Going left but target index is higher — go into prepended clones
        targetTrackIndex = index - totalThumbs;
      }

      // Animate to the target position
      setThumbPosition(getThumbLeft(targetTrackIndex), true);
      thumbTrackIndex = index;

      // If we animated into clone territory, snap back to real position after
      if (targetTrackIndex !== index) {
        snapTimer = setTimeout(function () {
          setThumbPosition(getThumbLeft(index), false);
          snapTimer = null;
        }, 320);
      }
    }

    thumbPrev.addEventListener('click', function (e) {
      e.stopPropagation();
      goToSlide(currentIndex - 1, -1);
    });

    thumbNext.addEventListener('click', function (e) {
      e.stopPropagation();
      goToSlide(currentIndex + 1, 1);
    });

    // Recalculate on resize
    window.addEventListener('resize', function () {
      setupThumbDimensions();
    });

    // Initial setup
    setupThumbDimensions();
  }

  // Init when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }
})();
